'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _visitorReceiveHandlers = require('../pubsub/handlers/visitorReceiveHandlers');

var visitorPubSubHandlers = _extends({}, _visitorReceiveHandlers.visitorReceiveHandlers);
exports.default = visitorPubSubHandlers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/middleware/visitorPubSubHandlers.js
// module id = 1271
// module chunks = 3